import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useSelector } from 'react-redux';

function Hero() {
  const eventData = useSelector((state) => state.event.eventData);
  console.log("eventData",eventData)
  const slides = [
    {
      image: `${eventData.theme[0].imageKey}`,
      title: `${eventData.theme[0].banner1title}`,
      pera: `${eventData.theme[0].banner1description }`,
    },
    {
      image: `${eventData.theme[1].imageKey}`,
      title: `${eventData.theme[1].banner2title}`,
      pera: `${eventData.theme[1].banner2description }`,

    },
    {
      image: `${eventData.theme[2].imageKey}`,
      title: `${eventData.theme[2].banner3title}`,
      pera: `${eventData.theme[2].banner3description }`,
    },
   
  ];

  return (
    <div>

    <div className="hero-3" id="hero">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{ delay: 3000 }}
        loop={true}
        pagination={{ clickable: true }}
        navigation
        className="hero-slider-3"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="hero-inner"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="container">
                <div className="hero-style3">
                  <h1 className="hero-title">{slide.title}</h1>
                  <p className="hero-text">
                  {slide.pera}
                  </p>
                 
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}

       
      </Swiper>
    </div>

     {/* <div class="hero3-wrapper">
        <div class="container">
            <div class="row justify-content-center align-items-end flex-row-reverse">
                <div class="col-lg-4">
                    <div class="hero3-swiper-custom">
                        <button data-slider-prev="#heroSlide3" class="swiper-button-next">
                            <img src="assets/img/icon/hero-arrow-right.svg" alt=""/></button>
                        <div class="swiper-pagination"></div>
                        <button data-slider-next="#heroSlide3" class="swiper-button-prev">
                            <img src="assets/img/icon/hero-arrow-left.svg" alt=""/></button>

                    </div>
                    <div class="swiper hero3Thumbs">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="hero-inner">
                                    <div class="hero3-card">
                                        <div class="hero-img">
                                            <img src="assets/img/hero/hero_bg_3_1.jpg" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="hero-inner">
                                    <div class="hero3-card">
                                        <div class="hero-img">
                                            <img src="assets/img/hero/hero_bg_3_2.jpg" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="hero-inner">
                                    <div class="hero3-card">
                                        <div class="hero-img">
                                            <img src="assets/img/hero/hero_bg_3_3.jpg" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="hero-inner">
                                    <div class="hero3-card">
                                        <div class="hero-img">
                                            <img src="assets/img/hero/hero_bg_3_4.jpg" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="hero-inner">
                                    <div class="hero3-card">
                                        <div class="hero-img">
                                            <img src="assets/img/hero/hero_bg_3_5.jpg" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="hero-booking style2">
                        <form action="mail.php" method="POST" class="booking-form style2 ajax-contact">
                            <div class="input-wrap">
                                <div class="row align-items-center justify-content-between">
                                    <div class="form-group col-md-6 col-xl-auto">
                                        <div class="icon">
                                            <i class="fa-light fa-route"></i>
                                        </div>
                                        <div class="search-input">
                                            <label>Destination</label>
                                            <select class=" nice-select" name="Destination" id="Destination">
                                                <option value="Select Destination" selected disabled>Select Destination
                                                </option>
                                                <option value="Australia">Australia</option>
                                                <option value="Dubai">Dubai</option>
                                                <option value="England">England</option>
                                                <option value="Sweden">Sweden</option>
                                                <option value="Thailand">Thailand</option>
                                                <option value="Egypt">Egypt</option>
                                                <option value="Saudi Arab">Saudi Arab</option>
                                                <option value="Switzerland">Switzerland</option>
                                                <option value="Scandinavia">Scandinavia</option>
                                                <option value="Western Europe">Western Europe</option>
                                                <option value="Indonesia">Indonesia</option>
                                                <option class="Italy">Italy</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6 col-xl-auto">
                                        <div class="icon">
                                            <i class="fa-regular fa-person-hiking"></i>
                                        </div>
                                        <div class="search-input">
                                            <label>Type</label>
                                            <select class=" nice-select" name="type" id="type">
                                                <option value="Adventure" selected disabled>Adventure</option>
                                                <option value="Beach">Beach</option>
                                                <option value="Group Tour">Group Tour</option>
                                                <option value="Couple Tour">Couple Tour</option>
                                                <option value="Family Tour">Family Tour</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6 col-xl-auto">
                                        <div class="icon">
                                            <i class="fa-light fa-clock"></i>
                                        </div>
                                        <div class="search-input">
                                            <label>Duration</label>
                                            <select class="form-select nice-select" name="Duration" id="Duration">
                                                <option value="Normal" selected disabled>Duration</option>
                                                <option value="1">1 days</option>
                                                <option value="2">2 days</option>
                                                <option value="3">3 days</option>
                                                <option value="4">4 days</option>
                                                <option value="5">5 days</option>
                                                <option value="6">6 days</option>
                                                <option value="7">7 days</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                </div>
                                <p class="form-messages mb-0 mt-3"></p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div> */}
    
    </div>
  );
}

export default Hero;
